module.exports = __webpack_public_path__ + "static/media/Lee.de658d21.mp4";